import { getUrlParameter, validateFileType } from './attachments';

$(document).ready(() => {
  const form = $('.upload-logo');

  addPopover('#company-documents .actions a');

  $('#companyLogoBtn').change(function (e) {
    const displayButton = e.currentTarget;
    validateFileType(this.children[0], form, displayButton);
  });

  // Checking to see if a new image has been added to the company logo and jump to it
  if (getUrlParameter('logo_upload')) {
    setTimeout(() => {
      window.location.hash = '#companyLogo';
    }, 50);
  }
});
